import { useState } from 'react';
import SchemaForm, { FormField } from '../../components/Forms/SchemaForm';
import VerificationPageLayout from '../../components/Layout/VerificationPageLayout';
import VerificationResultDisplay from '../../components/Verification/VerificationResultDisplay';
import { directorEnquiryService, directorEnquirySchema } from '../../services/verificationSystemServices/directorEnquiryService';
import { Alert, Box, CircularProgress } from '@mui/material';

const DirectorEnquiryReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (data: any) => {
        setIsLoading(true);
        setError(null);
        setResult(null);

        try {
            const response = await directorEnquiryService.executeReport(data);
            setResult(response);
        } catch (err: any) {
            setError(err.response?.data?.detail || err.message || 'An error occurred during verification');
        } finally {
            setIsLoading(false);
        }
    };

    const formSchema: FormField[] = [
        { name: 'idNo', label: 'ID Number', type: 'text', gridProps: { xs: 12, md: 6 }, required: false, dependencies: ['passportNo', 'firstName', 'surname', 'dob'], maxLength: 13 },
        { name: 'passportNo', label: 'Passport Number', type: 'text', gridProps: { xs: 12, md: 6 }, required: false, dependencies: ['idNo', 'firstName', 'surname', 'dob'] },
        { name: 'firstName', label: 'First Name', type: 'text', gridProps: { xs: 12, md: 4 }, required: false, dependencies: ['idNo', 'passportNo', 'surname', 'dob'] },
        { name: 'surname', label: 'Surname', type: 'text', gridProps: { xs: 12, md: 4 }, required: false, dependencies: ['idNo', 'passportNo', 'firstName', 'dob'] },
        { name: 'dob', label: 'Date of Birth', type: 'date', gridProps: { xs: 12, md: 4 }, required: false, dependencies: ['idNo', 'passportNo', 'firstName', 'surname'] },
        { name: 'voucherCode', label: 'Voucher Code', type: 'text', gridProps: { xs: 12, md: 6 }, required: false },
        { name: 'yourReference', label: 'Your Reference', type: 'text', gridProps: { xs: 12, md: 6 }, required: false },
    ];

    return (
        <VerificationPageLayout title="Director Enquiry Report">
            <Box mb={4}>
                <SchemaForm
                    schema={formSchema}
                    onSubmit={handleSubmit}
                    submitLabel={isLoading ? 'Enquiring…' : 'Enquire Director'}
                    validationSchema={directorEnquirySchema}
                />
            </Box>

            {isLoading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                    <CircularProgress sx={{ color: '#2D4677' }} />
                </Box>
            )}

            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

            {result && !isLoading && (
                <VerificationResultDisplay
                    title="Director Enquiry Report"
                    requestId={result.request_id}
                    success={result.success}
                    message={result.message}
                    data={result.report_data ?? result.match_data ?? null}
                />
            )}
        </VerificationPageLayout>
    );
};

export default DirectorEnquiryReport;
